import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const LeaveArrowIcon: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7923 17.1779L17.0923 17.1811L17.0728 6.85262L6.6914 6.84282L6.69301 5.14282L18.7696 5.15423L18.7923 17.1779Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5085 6.59384L5.79193 19.3104L4.58984 18.1084L17.3064 5.39176L18.5085 6.59384Z"
        fill="#1B1C1D"
      />
    </BaseIcon>
  );
};

export default LeaveArrowIcon;
